import Vue from 'vue'
import Router from 'vue-router'
import StagedCandidate from "./components/cvupload/StagedCandidate";
import CvUpload from "./components/cvupload/CvUpload";
import Consultant from "./views/Consultant";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            name: 'consultant',
            alias: '/App/:user/:token',
            path: '/Consultant/:user/:token',
            component: Consultant,
            children: [
                {
                    path: 'CvUpload',
                    name: 'cvupload',
                    component: CvUpload
                },
                {
                    path: 'CvUpload/:id',
                    name: 'stagedcandidate',
                    component: StagedCandidate
                },
                {
                    path: process.env.VUE_APP_ADMIN_ROUTE,
                    name: 'cvuploadadmin',
                    component: CvUpload
                },
                {
                    path: process.env.VUE_APP_ADMIN_ROUTE+'/:id',
                    name: 'stagedcandidateadmin',
                    component: StagedCandidate
                }
            ]
        }
    ]
});

export default router;
